import styled from 'styled-components';

export const EditCompressorFormContainer = styled.div`
  /* hide number input arrows - Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* hide number input arrows - Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }

  .switch-container {
    display: flex;
    align-items: center;
    gap: ${({ theme: { token } }) => token.marginSM}px;
  }

  .horizontal-label {
    margin-bottom: ${({ theme: { token } }) => token.marginLG}px;
  }

  .connected-to-row {
    display: flex;
    align-items: center;
  }

  .pipe {
    margin-top: 10px;
    height: 2px;
    background-color: ${({ theme: { token } }) => token.colorBorder};
  }

  .widget {
    z-index: 1;
  }

  .divider {
    margin: ${({ theme: { token } }) => token.margin}px 0;
  }
`;
